import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import LoginModal from '../Login/LoginModal';
import toast from 'react-hot-toast';

/**
 * 全局登录过期处理组件
 * 监听全局登录过期事件，显示登录弹窗
 */
const GlobalLoginExpiredHandler = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { user, logout } = useAuth();

  useEffect(() => {
    const handleLoginExpired = (event) => {
      // 如果用户已经登录，显示过期提示
      if (user) {
        toast.error(event.detail?.message || '登录已过期，请重新登录', {
          duration: 4000,
          position: 'top-center',
        });
      }
      
      // 清空认证状态
      logout();
      
      // 显示登录弹窗
      setShowLoginModal(true);
    };

    // 监听全局登录过期事件
    window.addEventListener('loginExpired', handleLoginExpired);

    return () => {
      window.removeEventListener('loginExpired', handleLoginExpired);
    };
  }, [user, logout]);

  const handleLoginSuccess = () => {
    setShowLoginModal(false);
    toast.success('登录成功', {
      duration: 2000,
      position: 'top-center',
    });
  };

  const handleCloseLogin = () => {
    setShowLoginModal(false);
  };

  return (
    <>
      {showLoginModal && (
        <LoginModal
          isOpen={showLoginModal}
          onClose={handleCloseLogin}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </>
  );
};

export default GlobalLoginExpiredHandler;